
import { OK } from 'http-status-codes'
import getAxiosInstance from '../../../helpers/get_axios_instance'

export class TablaDetallePorCondicionLinea3Service {
  static async getDataTablaDetallePorCondicionLinea3 () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_neto_etiqueta_sector3')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion por cereal sector 3.')
      return (data)
    })
  }

  static async getDataTablaDetallePorCondicionLinea3Total () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_neto_etiqueta_sector3_total')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion por cereal sector 3.')
      return (data)
    })
  }
}
